/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AppleSignInRequest,
  AuthSendEmailVerification200Response,
  AuthSendPasswordResetEmail200Response,
  AuthSendPasswordUpdatedEmail200Response,
  ChangePasswordFirstTime200Response,
  CheckOnboarding200Response,
  CompleteOnboardingRequest,
  ErrorResponse,
  GoogleSignInRequest,
  GoogleSignInResponseDto,
  Logout200Response,
  RefreshTokenRequest,
  SendAuthEmailRequest,
  UpdateProtocolDeployment200Response,
  UpdateProtocolDeploymentRequest,
} from '../models/index';
import {
    AppleSignInRequestFromJSON,
    AppleSignInRequestToJSON,
    AuthSendEmailVerification200ResponseFromJSON,
    AuthSendEmailVerification200ResponseToJSON,
    AuthSendPasswordResetEmail200ResponseFromJSON,
    AuthSendPasswordResetEmail200ResponseToJSON,
    AuthSendPasswordUpdatedEmail200ResponseFromJSON,
    AuthSendPasswordUpdatedEmail200ResponseToJSON,
    ChangePasswordFirstTime200ResponseFromJSON,
    ChangePasswordFirstTime200ResponseToJSON,
    CheckOnboarding200ResponseFromJSON,
    CheckOnboarding200ResponseToJSON,
    CompleteOnboardingRequestFromJSON,
    CompleteOnboardingRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GoogleSignInRequestFromJSON,
    GoogleSignInRequestToJSON,
    GoogleSignInResponseDtoFromJSON,
    GoogleSignInResponseDtoToJSON,
    Logout200ResponseFromJSON,
    Logout200ResponseToJSON,
    RefreshTokenRequestFromJSON,
    RefreshTokenRequestToJSON,
    SendAuthEmailRequestFromJSON,
    SendAuthEmailRequestToJSON,
    UpdateProtocolDeployment200ResponseFromJSON,
    UpdateProtocolDeployment200ResponseToJSON,
    UpdateProtocolDeploymentRequestFromJSON,
    UpdateProtocolDeploymentRequestToJSON,
} from '../models/index';

export interface AppleSignInOperationRequest {
    appleSignInRequest: AppleSignInRequest;
}

export interface AuthSendEmailVerificationRequest {
    sendAuthEmailRequest: SendAuthEmailRequest;
}

export interface AuthSendPasswordResetEmailRequest {
    sendAuthEmailRequest: SendAuthEmailRequest;
}

export interface CompleteOnboardingOperationRequest {
    completeOnboardingRequest: CompleteOnboardingRequest;
}

export interface GoogleSignInOperationRequest {
    googleSignInRequest: GoogleSignInRequest;
}

export interface RefreshTokenOperationRequest {
    refreshTokenRequest: RefreshTokenRequest;
}

export interface UpdateProtocolDeploymentOperationRequest {
    updateProtocolDeploymentRequest: UpdateProtocolDeploymentRequest;
}

/**
 * 
 */
export class AuthenticationApi extends runtime.BaseAPI {

    /**
     * Verifies the Firebase ID token issued after the client signs in with the Apple credential, then provisions claims and returns a custom token.
     * Sign in with Apple
     */
    async appleSignInRaw(requestParameters: AppleSignInOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleSignInResponseDto>> {
        if (requestParameters['appleSignInRequest'] == null) {
            throw new runtime.RequiredError(
                'appleSignInRequest',
                'Required parameter "appleSignInRequest" was null or undefined when calling appleSignIn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/apple-signin`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AppleSignInRequestToJSON(requestParameters['appleSignInRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleSignInResponseDtoFromJSON(jsonValue));
    }

    /**
     * Verifies the Firebase ID token issued after the client signs in with the Apple credential, then provisions claims and returns a custom token.
     * Sign in with Apple
     */
    async appleSignIn(requestParameters: AppleSignInOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleSignInResponseDto> {
        const response = await this.appleSignInRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generates a Firebase Admin email verification link and sends it via Cellera\'s email service using a branded template.
     * Send email verification via Cellera SMTP
     */
    async authSendEmailVerificationRaw(requestParameters: AuthSendEmailVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthSendEmailVerification200Response>> {
        if (requestParameters['sendAuthEmailRequest'] == null) {
            throw new runtime.RequiredError(
                'sendAuthEmailRequest',
                'Required parameter "sendAuthEmailRequest" was null or undefined when calling authSendEmailVerification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/send-email-verification`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendAuthEmailRequestToJSON(requestParameters['sendAuthEmailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthSendEmailVerification200ResponseFromJSON(jsonValue));
    }

    /**
     * Generates a Firebase Admin email verification link and sends it via Cellera\'s email service using a branded template.
     * Send email verification via Cellera SMTP
     */
    async authSendEmailVerification(requestParameters: AuthSendEmailVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthSendEmailVerification200Response> {
        const response = await this.authSendEmailVerificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generates a Firebase Admin password reset link and sends it via Cellera\'s email service using a branded template.
     * Send password reset email via Cellera SMTP
     */
    async authSendPasswordResetEmailRaw(requestParameters: AuthSendPasswordResetEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthSendPasswordResetEmail200Response>> {
        if (requestParameters['sendAuthEmailRequest'] == null) {
            throw new runtime.RequiredError(
                'sendAuthEmailRequest',
                'Required parameter "sendAuthEmailRequest" was null or undefined when calling authSendPasswordResetEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/send-password-reset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendAuthEmailRequestToJSON(requestParameters['sendAuthEmailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthSendPasswordResetEmail200ResponseFromJSON(jsonValue));
    }

    /**
     * Generates a Firebase Admin password reset link and sends it via Cellera\'s email service using a branded template.
     * Send password reset email via Cellera SMTP
     */
    async authSendPasswordResetEmail(requestParameters: AuthSendPasswordResetEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthSendPasswordResetEmail200Response> {
        const response = await this.authSendPasswordResetEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sends a confirmation email to the currently authenticated user after a password change.
     * Send password updated confirmation email
     */
    async authSendPasswordUpdatedEmailRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthSendPasswordUpdatedEmail200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/password-updated-email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthSendPasswordUpdatedEmail200ResponseFromJSON(jsonValue));
    }

    /**
     * Sends a confirmation email to the currently authenticated user after a password change.
     * Send password updated confirmation email
     */
    async authSendPasswordUpdatedEmail(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthSendPasswordUpdatedEmail200Response> {
        const response = await this.authSendPasswordUpdatedEmailRaw(initOverrides);
        return await response.value();
    }

    /**
     * Updates the already_change_password field to true for patient users and sends a confirmation email. Only accessible by patient role.
     * Mark patient password as changed for the first time
     */
    async changePasswordFirstTimeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangePasswordFirstTime200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/change-password-first-time`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangePasswordFirstTime200ResponseFromJSON(jsonValue));
    }

    /**
     * Updates the already_change_password field to true for patient users and sends a confirmation email. Only accessible by patient role.
     * Mark patient password as changed for the first time
     */
    async changePasswordFirstTime(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangePasswordFirstTime200Response> {
        const response = await this.changePasswordFirstTimeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns whether the user has completed onboarding or still requires onboarding
     * Check onboarding completion status
     */
    async checkOnboardingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckOnboarding200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/check-onboarding`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckOnboarding200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns whether the user has completed onboarding or still requires onboarding
     * Check onboarding completion status
     */
    async checkOnboarding(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckOnboarding200Response> {
        const response = await this.checkOnboardingRaw(initOverrides);
        return await response.value();
    }

    /**
     * Complete user onboarding
     */
    async completeOnboardingRaw(requestParameters: CompleteOnboardingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['completeOnboardingRequest'] == null) {
            throw new runtime.RequiredError(
                'completeOnboardingRequest',
                'Required parameter "completeOnboardingRequest" was null or undefined when calling completeOnboarding().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/complete-onboarding`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompleteOnboardingRequestToJSON(requestParameters['completeOnboardingRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Complete user onboarding
     */
    async completeOnboarding(requestParameters: CompleteOnboardingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.completeOnboardingRaw(requestParameters, initOverrides);
    }

    /**
     * Sign in with Google OAuth
     */
    async googleSignInRaw(requestParameters: GoogleSignInOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleSignInResponseDto>> {
        if (requestParameters['googleSignInRequest'] == null) {
            throw new runtime.RequiredError(
                'googleSignInRequest',
                'Required parameter "googleSignInRequest" was null or undefined when calling googleSignIn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/google-signin`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GoogleSignInRequestToJSON(requestParameters['googleSignInRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleSignInResponseDtoFromJSON(jsonValue));
    }

    /**
     * Sign in with Google OAuth
     */
    async googleSignIn(requestParameters: GoogleSignInOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleSignInResponseDto> {
        const response = await this.googleSignInRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Revokes Firebase refresh tokens for all users. For patient users, also invalidates the session.
     * Logout user and revoke tokens
     */
    async logoutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Logout200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => Logout200ResponseFromJSON(jsonValue));
    }

    /**
     * Revokes Firebase refresh tokens for all users. For patient users, also invalidates the session.
     * Logout user and revoke tokens
     */
    async logout(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Logout200Response> {
        const response = await this.logoutRaw(initOverrides);
        return await response.value();
    }

    /**
     * Refresh Firebase token
     */
    async refreshTokenRaw(requestParameters: RefreshTokenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['refreshTokenRequest'] == null) {
            throw new runtime.RequiredError(
                'refreshTokenRequest',
                'Required parameter "refreshTokenRequest" was null or undefined when calling refreshToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/refresh-token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RefreshTokenRequestToJSON(requestParameters['refreshTokenRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Refresh Firebase token
     */
    async refreshToken(requestParameters: RefreshTokenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.refreshTokenRaw(requestParameters, initOverrides);
    }

    /**
     * Updates the isAwaitingProtocolDeployment field for a provider user by email address.
     * Update protocol deployment status for a provider
     */
    async updateProtocolDeploymentRaw(requestParameters: UpdateProtocolDeploymentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateProtocolDeployment200Response>> {
        if (requestParameters['updateProtocolDeploymentRequest'] == null) {
            throw new runtime.RequiredError(
                'updateProtocolDeploymentRequest',
                'Required parameter "updateProtocolDeploymentRequest" was null or undefined when calling updateProtocolDeployment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/update-protocol-deployment`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProtocolDeploymentRequestToJSON(requestParameters['updateProtocolDeploymentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateProtocolDeployment200ResponseFromJSON(jsonValue));
    }

    /**
     * Updates the isAwaitingProtocolDeployment field for a provider user by email address.
     * Update protocol deployment status for a provider
     */
    async updateProtocolDeployment(requestParameters: UpdateProtocolDeploymentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateProtocolDeployment200Response> {
        const response = await this.updateProtocolDeploymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
